/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import iconSrc from '../../utils/iconSrc';
import {
  BreadcrumbList,
  BreadcrumbListItem,
  BreadcrumbAnchor,
  ArrowSVG,
} from './styles';

const Breadcrumbs = ({ crumbs }) =>
  crumbs && crumbs.length ? (
    <nav aria-label="Breadcrumb" data-funnelbacknoindex>
      <BreadcrumbList>
        {crumbs.slice(0, -1).map((crumb, i) => (
          <BreadcrumbListItem key={`${crumb.id}-${i}`}>
            <ArrowSVG src={iconSrc('chevron-left')} />
            <BreadcrumbAnchor link={{ path: crumb.path }}>
              {crumb.label}
            </BreadcrumbAnchor>
          </BreadcrumbListItem>
        ))}
        <BreadcrumbListItem>
          {crumbs[crumbs.length - 1].label}
        </BreadcrumbListItem>
      </BreadcrumbList>
    </nav>
  ) : null;

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Breadcrumbs;
